import { Select } from 'common/components/Inputs/Select/Select.tsx';
import {
  PROVISIONING_STATUS,
  PROVISIONING_STATUS_LABEL,
  ProvisioningStatusFilter,
  provisioningStatusFilterSchema,
} from '@/activityLog/bulkProvisioning/constants/provisioningStatus.ts';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';

type StatusSelectProps = {
  value: ProvisioningStatusFilter;
  onChange: (value: ProvisioningStatusFilter) => void;
  'data-testid'?: string;
};

export const StatusSelect = ({ value, onChange, ...props }: StatusSelectProps) => {
  const { t } = useTranslation();

  return (
    <Select
      data-testid={props['data-testid']}
      label={t('common.status')}
      name={t('common.status')}
      value={value}
      onChange={(event) => {
        const status = provisioningStatusFilterSchema.parse(event.target.value);
        onChange(status);
      }}
    >
      <MenuItem value="">{t('common.none')}</MenuItem>
      <MenuItem value={PROVISIONING_STATUS.PROCESSING_IN_PROGRESS}>
        {PROVISIONING_STATUS_LABEL.PROCESSING_IN_PROGRESS}
      </MenuItem>
      <MenuItem value={PROVISIONING_STATUS.PROCESSING_SUCCEED}>
        {PROVISIONING_STATUS_LABEL.PROCESSING_SUCCEED}
      </MenuItem>
      <MenuItem value={PROVISIONING_STATUS.PROCESSING_FAILED}>
        {PROVISIONING_STATUS_LABEL.PROCESSING_FAILED}
      </MenuItem>
      <MenuItem value={PROVISIONING_STATUS.DATA_EXTRACTION_PENDING}>
        {PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_PENDING}
      </MenuItem>
      <MenuItem value={PROVISIONING_STATUS.DATA_EXTRACTION_IN_PROGRESS}>
        {PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_IN_PROGRESS}
      </MenuItem>
      <MenuItem value={PROVISIONING_STATUS.DATA_EXTRACTION_FAILED}>
        {PROVISIONING_STATUS_LABEL.DATA_EXTRACTION_FAILED}
      </MenuItem>
    </Select>
  );
};
